//External
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

//Internal
import {
  getBrandCategoryListAsUserBehaviour,
  get_cookie,
  makeLocalStorageKey,
  makeStorageKeyForCookie,
} from "utils";
import { getVehicalDetailData } from "store/actions";
import store from "store";
// import CookiesModal from "components/modals/cookiesModal";

// import HomeTop from "../hometop";
const HomeTop = dynamic(() => import("../hometop"));
const DynamicLazyDrivenow = dynamic(() => import("../drivenow"));
const DynamicLazyRecentlyViewed = dynamic(() => import("../recentlyviewed"));
const DynamicLazyBrowsebymake = dynamic(() => import("../browsebymake"));
const DynamicLazyBrowsebytype = dynamic(() => import("../browsebytype"));
const DynamicLazyHomeFaqs = dynamic(() => import("../homefaqs"));
const DynamicLazyFeatures = dynamic(() => import("../features"));
const DynamicLazyGoogleReviews = dynamic(() => import("../googleReviews"));
const DynamicLazyThespecials = dynamic(() => import("../thespecials"));
const DynamicLazyHomebottom = dynamic(() => import("../homebottom"));

/*******************
   @Purpose : Used for home page
   @Parameter : {brandList,categoryList,currentLocationId,data,features,slug1,slug2,slug3}
   @Author : INIC
  *******************/
const Home = ({
  brandList,
  categoryList,
  currentLocationId,
  data,
  features,
  slug1,
  slug2,
  slug3,
}) => {
  const [brandListAsUserBehaviour, setBrandListAsUserBehaviour] = useState([]);
  const [categoryListAsUserBehaviour, setCategoryListAsUserBehaviour] =
    useState([]);
  const [specialData, setSpecialData] = useState([]);
  const [hdn, setHdn] = useState(false);
  const [isMobileApp, setIsMobileApp] = useState();

  /*******************
  @purpose : get brand list as user behaviour 
  @Author : INIC
  ******************/
  useEffect(() => {
    setBrandListAsUserBehaviour(
      getBrandCategoryListAsUserBehaviour(brandList, "brand"),
    );
  }, [brandList]);

  /*******************
  @purpose : get brand list as user behaviour 
  @Author : INIC
  ******************/
  useEffect(() => {
    setCategoryListAsUserBehaviour(
      getBrandCategoryListAsUserBehaviour(categoryList, "category"),
    );
  }, [categoryList]);

  /*******************
  @purpose : Get related vehicle of last visited vehicle
  @Author : INIC
  ******************/
  useEffect(async () => {
    const storageKey = makeLocalStorageKey("v2_v_slug");
    if (localStorage.getItem(storageKey)) {
      const slug = localStorage.getItem(storageKey);

      // get vehicle detail data
      const vehicalDetailData = await store.dispatch(
        getVehicalDetailData(currentLocationId, slug),
      );

      /*
      const arr1 = vehicalDetailData?.related_vehicle;
      const len = data?.special?.length - arr1?.length;
      const arr2 = data?.special?.slice(0, len);
      */

      if (vehicalDetailData?.related_vehicle && data?.special) {
        const specialMergeArr = mergeAndRemoveDuplicatesByProperty(
          vehicalDetailData?.related_vehicle,
          data?.special,
        );
        setSpecialData(specialMergeArr);
      } else {
        setSpecialData(data?.special);
      }
    } else {
      setSpecialData(data?.special);
    }

    const hdnVal = makeStorageKeyForCookie("hdn");
    if (get_cookie(hdnVal)) {
      setHdn(false);
    } else {
      setHdn(true);
    }
  }, [slug1, slug2, slug3]);

  /*******************
  @purpose : Merge two array and remove duplicate vehicle
  @Author : INIC
  ******************/
  const mergeAndRemoveDuplicatesByProperty = (arr1, arr2) => {
    let storeVehicleLength = arr1.length;
    let specialLength = arr2.length;
    const mergedArray = [...arr1, ...arr2];

    // Use a Map to keep track of unique objects based on the specified property
    const uniqueMap = new Map();
    mergedArray.forEach((obj) => {
      const key = obj["slug_id"];
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, obj);
      }
    });

    // Convert the Map values back to an array
    const uniqueArray = Array.from(uniqueMap.values());
    if (specialLength > storeVehicleLength) {
      return uniqueArray.slice(0, specialLength);
    } else {
      return uniqueArray;
    }
  };

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <HomeTop
        data={data?.page_details}
        slug1={slug1}
        slug2={slug2}
        currentLocationId={currentLocationId}
      />
      {/* Section Divider  */}
      {/* {isMobileApp !== "yes" && (
        <div className="custom-container d-block">
          <div className="section-divider wb-section"></div>
        </div>
      )} */}
      {data && data?.recentlyViews?.length > 0 && (
        <>
          <DynamicLazyRecentlyViewed
            data={data?.recentlyViews}
            slug1={slug1}
            slug2={slug2}
            slug3={slug3}
          />

          <div className="custom-container">
            <div className="section-divider wb-section"></div>
          </div>
        </>
      )}
      {data?.page_details?.show_drive_now &&
        data?.drive_now &&
        data?.drive_now?.length > 0 &&
        hdn && (
          <>
            <DynamicLazyDrivenow
              data={data?.drive_now}
              slug1={slug1}
              slug2={slug2}
              slug3={slug3}
            />

            <div className="custom-container">
              <div className="section-divider wb-section"></div>
            </div>
          </>
        )}
      {data?.page_details?.show_search_by &&
        brandList &&
        brandList?.length > 0 && (
          <>
            <DynamicLazyBrowsebymake
              brandList={brandListAsUserBehaviour}
              slug1={slug1}
              slug2={slug2}
              slug3={slug3}
            />
          </>
        )}
      {data?.page_details?.show_search_by &&
        categoryList &&
        categoryList?.length > 0 && (
          <>
            <DynamicLazyBrowsebytype
              categoryList={categoryListAsUserBehaviour}
              slug1={slug1}
              slug2={slug2}
              slug3={slug3}
            />

            <div className="custom-container">
              <div className="section-divider wb-section"></div>
            </div>
          </>
        )}
      {data?.page_details?.show_special_vehicles &&
        data?.special &&
        data?.special?.length > 0 &&
        specialData?.length > 0 && (
          <>
            <section className="the-special py-75">
              <div className="custom-container">
                <div className="section-heading">
                  <h3 className="mb-0">Trending</h3>
                </div>

                <DynamicLazyThespecials
                  data={specialData}
                  slug1={slug1}
                  slug2={slug2}
                  slug3={slug3}
                  flag="home"
                  whichPage="home"
                />
              </div>
            </section>
            {/* Section Divider  */}
            <div className="custom-container">
              <div className="section-divider wb-section featured-seprator-mb"></div>
            </div>
          </>
        )}
      {data?.page_details?.show_featured &&
        features &&
        features?.length > 0 &&
        isMobileApp !== "yes" && (
          <>
            <DynamicLazyFeatures features={features} />
            {/* Section Divider  */}
            <div className="custom-container">
              <div className="section-divider wb-section"></div>
            </div>
          </>
        )}
      {isMobileApp !== "yes" &&
        data?.faqs &&
        data?.page_details?.show_faqs &&
        data?.faqs?.length > 0 && (
          <>
            <DynamicLazyHomeFaqs faqs={data?.faqs} />
            {/* <div className="custom-container">
              <div className="section-divider wb-section"></div>
            </div> */}
          </>
        )}

      {data?.page_details?.google_reviews?.length > 0 &&
        isMobileApp !== "yes" && (
          <>
            <DynamicLazyGoogleReviews data={data.page_details.google_reviews} />
            {/* Section Divider  */}
            <div className="custom-container">
              <div className="section-divider wb-section"></div>
            </div>
          </>
        )}
      {isMobileApp !== "yes" && (
        <DynamicLazyHomebottom data={data?.page_details} />
      )}
      {/* Section Divider  */}
      {isMobileApp !== "yes" && (
        <div className="custom-container">
          <div className="section-divider wb-section"></div>
        </div>
      )}
      {/* {isMobileApp !== "yes" && <CookiesModal />} */}
    </>
  );
};

export default Home;
